import generalUpload from "../_section/upload.class";
import React from "react";

export class userGiftCertificateUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [{
        name: 'documentDate',
        label: 'Document Date',
        type: 'date',
    },
        {
            name: 'gifterNames',
            label: <div>Gifter Names   <div><small>eg John Doe (Father) & Jane Doe (Mother)</small></div></div>,
            type: 'text',
        },
        {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
        }]
}

export class adminGiftCertificateUpload extends userGiftCertificateUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(1, 'year'),
            })
        }
    }

    getSectionSummary = () => {
        /// there may be many docs that need to be summed

        const totalGiftedAmount = this.activeUploads.reduce((acc,cur)=>{
            if (cur?.values?.amount) {
                return acc + cur.values.amount
            }
            return acc
        }, 0)

        return [{
            name: this.personalTitle,
            tags: [
                {
                    name: 'Total Gifts', value: totalGiftedAmount
                }
            ]
        }]
    }
}
